import React, { Fragment, useState, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import MetisMenu from 'react-metismenu';
import { MainNav, CampaignNav } from './NavItems';
import { useAuth } from '../../Context/Auth/AuthContext';
import { useHistory } from 'react-router-dom';
import Strings from '../../translations/Translations';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';

function Nav() {
  const { currentCampaign, activeCampaign, activeLinkTo } = useAuth();
  const history = useHistory();

  const [modalCreateVideo, setModalCreateVideo] = useState(false);
  const toggleModalCreateVideo = useCallback(() => {
    setModalCreateVideo(!modalCreateVideo);
  }, [setModalCreateVideo, modalCreateVideo]);

  return (
    <Fragment>
      {!activeCampaign && (
        <Fragment>
          <div className="mt-3"></div>
          <MetisMenu
            content={MainNav}
            activeLinkTo={activeLinkTo}
            className="vertical-nav-menu"
            iconNamePrefix=""
            classNameStateIcon="pe-7s-angle-down"
          />
        </Fragment>
      )}

      {activeCampaign && (
        <Fragment>
          <h5 className="app-sidebar__heading">{currentCampaign && currentCampaign.coln}</h5>
          <MetisMenu
            content={CampaignNav}
            activeLinkTo={activeLinkTo}
            className="vertical-nav-menu"
            iconNamePrefix=""
            classNameStateIcon="pe-7s-angle-down"
            onSelected={(evt) => {
              const currentHref = evt.currentTarget.href;
              if (currentHref.includes('#/campaign/create-video')) {
                evt.preventDefault();
                toggleModalCreateVideo();
              }
            }}
          />

        <Modal
          isOpen={modalCreateVideo}
          toggle={toggleModalCreateVideo}
        >
          <ModalHeader toggle={toggleModalCreateVideo}>
            {Strings('create_video')}
          </ModalHeader>
          <ModalBody className='text-center'>
            <Button
              size='lg'
              className='mr-2 mb-2'
              outline
              color='primary'
              onClick={() => {
                toggleModalCreateVideo();
                history.push(`/campaign/create-video?create=2`);
              }}
            >
              {Strings('auto_video')}
            </Button>
            <Button
              size='lg'
              className='mr-2 mb-2'
              outline
              color='primary'
              onClick={() => {
                toggleModalCreateVideo();
                history.push(`/campaign/create-video`);
              }}
            >
              {Strings('step_by_step')}
            </Button>
          </ModalBody>
        </Modal>

        </Fragment>
      )}


    </Fragment>
  );
}

export default withRouter(Nav);
